import { render, staticRenderFns } from "./PlayerDataAuditWhiteListPage.vue?vue&type=template&id=4b5af881&scoped=true"
import script from "./PlayerDataAuditWhiteListPage.vue?vue&type=script&lang=js"
export * from "./PlayerDataAuditWhiteListPage.vue?vue&type=script&lang=js"
import style0 from "./PlayerDataAuditWhiteListPage.vue?vue&type=style&index=0&id=4b5af881&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5af881",
  null
  
)

export default component.exports